import { SET_SERVERTIME_INFO, RESTE_ALL_INFO_DATA } from "../../action/info/type"

const initalState = {

    serverTime: new Date(),
    
}

const infoReducer = (state = initalState, action) => {

    switch(action.type){

        case SET_SERVERTIME_INFO : 
            return {
                ...state,
                serverTime: action.payload,
            }

        case RESTE_ALL_INFO_DATA :
            return {
                ...state,
                ...initalState
            }

        default : 
            return state

    }

}

export default infoReducer